import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectRoute = ({ children }) => {
    const auth = localStorage.getItem('tykoon_access');
    if (auth) {
       return <Navigate to={'/'} />
    }
    return children;
}

export default ProtectRoute